<template>
  <div>
    <section>
      <!--  部门结构-->
      <div style="color: #999999; margin-bottom: 31px">
        {{ $t("message.sectoralStructure") }}
      </div>
      <el-tree :data="organizationData" node-key="id" default-expand-all :props="{
        children: 'childs',
        label: 'name',
      }" :expand-on-click-node="false">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span style="display: inline-block; margin-right: 100px">{{
            node.label
          }}</span>
          <span>
            <el-button size="mini" v-if="data.parent_id === 0 && isAuth(119)" style="background: #2c96e7; color: #fff"
              @click="appendOrganizationMember">
              <!--            添加-->
              {{ $t("message.add") }}
            </el-button>
            <el-button size="mini" style="background: #15ad3c; color: #fff" @click="() => editOrganizationMember(data)"
              v-if="isAuth(120)">
              <!--            编辑-->
              {{ $t("message.redact") }}
            </el-button>
            <el-button v-if="data.parent_id !== 0 && isAuth(121)" size="mini" style="background: #333333; color: #fff"
              @click="() => removeOrganizationMember(data)">
              <!--            删除-->
              {{ $t("message.delete") }}
            </el-button>
          </span>
        </span>
      </el-tree>
      <!--  提示-->
      <el-dialog :title="$t('message.hint')" :close-on-click-modal="false"
        :visible.sync="removeOrganizationMemberDialogVisible" width="30%" :before-close="handleClose">
        <!--    确认是否删除当前层级，层级下包含内容会同步删除-->
        <span>{{
          $t(
            "message.checkWhetherToDeleteTheCurrentLevelTheContentContainedInTheLevelWillBeDeletedSimultaneously"
          )
        }}</span>
        <span slot="footer" class="dialog-footer">
          <!--      取 消-->
          <el-button @click="removeOrganizationMemberDialogVisible = false">{{
            $t("message.cancel")
          }}</el-button>
          <!--      确 定-->
          <el-button type="primary" @click="confirmRemoveOrganizationMember">{{
            $t("message.confirm")
          }}</el-button>
        </span>
      </el-dialog>
      <!--  编辑部门-->
      <el-dialog :title="$t('message.editorialDepartment')" :close-on-click-modal="false"
        :visible.sync="editOrganizationMemberDialogVisible" width="30%">
        <div class="flexAndCenter" style="margin-bottom: 30px">
          <!--      上级部门-->
          <div class="label">{{ $t("message.editorialDepartment") }}</div>
          <!--      点击部门选项，可以搜索，默认显示当前部门-->
          <el-cascader :options="organizationData" v-model="parent_id" :props="{
            checkStrictly: true,
            label: 'name',
            children: 'childs',
            expandTrigger: 'hover',
            value: 'id',
          }" clearable style="width: 100%" :placeholder="$t(
  'message.clickTheDepartmentOptionToSearchAndDisplayTheCurrentDepartmentByDefault'
)
  " @change="getValue"></el-cascader>
          <!--      点击部门选项，可以搜索，默认显示当前部门-->
        </div>
        <div class="flexAndCenter">
          <!--      部门名称-->
          <div class="label">{{ $t("message.industryTitle") }}</div>
          <el-input v-model="departmentName"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <!--      取 消-->
          <el-button @click="editOrganizationMemberDialogVisible = false">{{
            $t("message.cancel")
          }}</el-button>
          <!--      确 定-->
          <el-button type="primary" @click="confirmUpdateOrganizationMember">{{
            $t("message.confirm")
          }}</el-button>
        </span>
      </el-dialog>
      <!--  新增下级部门-->
      <el-dialog :title="$t('message.newSubordinateDepartments')" :close-on-click-modal="false"
        :visible.sync="appendOrganizationMemberDialogVisible" width="30%">
        <div class="flexAndCenter" style="margin-bottom: 30px">
          <!--      上级部门-->
          <div class="label">{{ $t("message.editorialDepartment") }}</div>
          <el-cascader :options="organizationData" v-model="parent_id" :props="{
            checkStrictly: true,
            label: 'name',
            children: 'childs',
            expandTrigger: 'hover',
            value: 'id',
          }" clearable style="width: 100%" :placeholder="$t(
  'message.clickTheDepartmentOptionToSearchAndDisplayTheCurrentDepartmentByDefault'
)
  " @change="getValue"></el-cascader>
          <!--      点击部门选项，可以搜索，默认显示当前部门-->
        </div>
        <div class="flexAndCenter">
          <!--      部门名称-->
          <div class="label">{{ $t("message.industryTitle") }}</div>
          <el-input v-model="departmentName"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <!--      保存-->
          <el-button type="primary" @click="confirmAppendOrganizationMember">{{
            $t("message.save")
          }}</el-button>
        </span>
      </el-dialog>
    </section>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      removeOrganizationMemberDialogVisible: false,
      appendOrganizationMemberDialogVisible: false,
      editOrganizationMemberDialogVisible: false,
      parent_id: "",
      departmentName: "",
      organizationData: [],
      confirmOperationInfo: {},
    };
  },
  created() {
    this.getOrganizationList();
  },
  methods: {
    //数据获取
    getOrganizationList() {
      this.$api.roleApi.organizationList().then((res) => {
        this.organizationData = res.data;
      });
    },
    handleClose(done) {
      // 确认关闭？
      this.$confirm(this.$t("message.sureToClose"))
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    //删除组织弹窗
    removeOrganizationMember(data) {
      this.confirmOperationInfo = data;
      this.removeOrganizationMemberDialogVisible = true;
    },
    //添加组织弹窗
    appendOrganizationMember() {
      this.confirmOperationInfo = {}
      this.parent_id = ''
      this.appendOrganizationMemberDialogVisible = true;
    },
    //更新上级目录
    getValue(e) {
      this.parent_id = e[e.length - 1];
      console.log(this.parent_id);
    },
    //编辑组织弹窗
    editOrganizationMember(data) {
      this.confirmOperationInfo = data;
      this.departmentName = this.confirmOperationInfo.name;
      this.editOrganizationMemberDialogVisible = true;
    },
    //删除组织
    confirmRemoveOrganizationMember() {
      this.$api.roleApi
        .deleteOrganization({
          id: this.confirmOperationInfo.id,
        })
        .then((res) => {
          this.removeOrganizationMemberDialogVisible = false;
          this.$message.success(res.msg);
          this.getOrganizationList();
        });
    },
    //编辑组织
    confirmUpdateOrganizationMember() {
      this.$api.roleApi
        .updateOrganization({
          id: this.confirmOperationInfo.id,
          name: this.departmentName,
          parent_id: this.parent_id,
        })
        .then((res) => {
          this.editOrganizationMemberDialogVisible = false;
          this.$message.success(res.msg);
          this.getOrganizationList();
        });
    },
    //添加组织
    confirmAppendOrganizationMember() {
      if (this.parent_id === "" && this.departmentName === "") {
        // 缺少必填项
        this.$message.error($t("message.requiredFieldsAreMissing"));
        return;
      }
      this.$api.roleApi
        .appendOrganization({
          parent_id: this.parent_id,
          name: this.departmentName,
        })
        .then((res) => {
          this.appendOrganizationMemberDialogVisible = false;
          this.$message.success(res.msg);
          this.getOrganizationList();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.flexAndCenter {
  display: flex;
  align-items: center;
}

section {
  border-radius: 8px;
  background: #f8f8f8;
  padding: 24px;

  .el-tree {
    background: transparent !important;

    /deep/ .el-tree-node__content {
      margin-bottom: 20px;
    }

    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }

    /deep/.el-tree-node__expand-icon {
      font-size: 20px;
    }
  }

  .label {
    width: 100px;
  }
}
</style>